/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ITileListItemViewProps } from '@msdyn365-commerce-modules/tile-list/src/modules/tile-list-item';
import { ITileListItemProps as ITileListItemExtProps } from '../definition-extensions/tile-list-item.ext.props.autogenerated';

/**
 *
 * ITileListItemViewProps component.
 * @param props - Component props.
 * @returns TileListView.
 */
const renderTileListItemContent = (props: ITileListItemViewProps & ITileListItemExtProps<{}>): JSX.Element => {
    const {
        heading,
        paragraph,
        backgroundImage,
        links,
        thumbnailImage,
        tileListContainer,
        tileListImageContainer,
        tileListThumbnailImageContainer,
        tileListHeadingContainer
    } = props;

    const isAuthenticated = props.context.request.user.isAuthenticated;

    // Ajout dynamique de la classe free-access
    const containerProps = {
        ...tileListContainer,
        className: [tileListContainer.className, isAuthenticated ? '' : 'guest-only', props.config?.freeAccess ? 'free-access' : '']
            .filter(Boolean)
            .join(' ')
    };

    return (
        <Node {...containerProps}>
            <Node {...tileListImageContainer}>{backgroundImage}</Node>
            <Node {...tileListHeadingContainer}>
                {heading}
                {paragraph}
                {links}
            </Node>
            <Node {...tileListThumbnailImageContainer}>{thumbnailImage}</Node>
        </Node>
    );
};

/**
 *
 * TileListItemViewProps component.
 * @param props - Component props.
 * @returns TileListView.
 */
export const TileListItemViewComponent: React.FC<ITileListItemViewProps & ITileListItemExtProps<{}>> = props => {
    const { tileListItem } = props;
    return <Module {...tileListItem}>{renderTileListItemContent(props)}</Module>;
};

export default TileListItemViewComponent;
